export class ccServer {
	 constructor() {
	 	this.serverUrl = [];
	 }
	 findUrl(type){
	 	if(this.serverUrl.length == 0) return false
	 	this.serverUrl.find((serverUrlInfo)=>{return serverUrlInfo.type == type})
	 }
} 
